import { SnackBarService } from '../../../../../services/snackbar.service';
import { MessageService } from './../../../../../services/messages.service';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BadPressMatchRecord } from './../../badpress-match.model';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { Observable } from 'rxjs/Observable';
import { WarmUpService } from './../../../../../services/warmup/warmup.service';
import { OnInit, Component, ChangeDetectorRef } from '@angular/core';
import { BadPressEntity } from 'app/entities/monitoring/actual/badpress-match.model';
import { BadPressService } from 'app/entities/monitoring/actual/badpress/bad-press.service';

@Component({
  templateUrl: './resolve-badpress.component.html',
})

/**
 * Dialog component to resolve bad press match.
 *
 * @author jagpreet.singh@vernuso.com  (Jagpreet Singh)
 */
export class ResolveBadPressMatchComponent implements OnInit {
  resolveForm: FormGroup;
  badPressMatchRecord: BadPressMatchRecord;
  relationEntityId: number;
  matchResolutions: ApplicationValue[];
  selectedMatchResolution: string;
  falseMatchReasons: ApplicationValue[];
  formErrors = {
    'matchResolution': '',
  };

  validationMessages = {
    'matchResolution': {
      'required': 'Required field value.',
    },
  };

  constructor(private badPressService: BadPressService,
    private warmUpService: WarmUpService,
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService) { }

  ngOnInit() {
    this.buildForm();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.PANAMA_PAPERS_MATCH_RESOLUTION));
    this.setUpFalseMatchReasons(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.FALSE_MATCH_REASONS));
    this.populateForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.resolveForm = this.formBuilder.group({
      matchResolution: ['', Validators.required],
      comments: [''],
      falseMatch: [''],
    });
    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.resolveForm) {
      return;
    }
    const form = this.resolveForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  populateForm() {
    if (this.badPressMatchRecord) {
      this.resolveForm.patchValue({
        matchResolution: this.badPressMatchRecord.matchResolution,
        comments: this.badPressMatchRecord.comments,
        falseMatch: this.badPressMatchRecord.falseMatchReason,
      });
      this.selectedMatchResolution = this.badPressMatchRecord.matchResolution.toString();
    }

  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  setUpFalseMatchReasons(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.falseMatchReasons = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.falseMatchReasons = dropDownValues;
    }
  }

  selectMatchResolution(event) {
    this.selectedMatchResolution = event.value;
  }

  isSelectedMatchFalse(): boolean {
    if (this.matchResolutions) {
      const falseMatchId = this.matchResolutions.find(matchResolution => matchResolution.name === 'False').id;
      return this.selectedMatchResolution == falseMatchId.toString();
    }
    return false;
  }

  onSubmit({ value, valid }) {
    const badPressMatchRecord = new BadPressMatchRecord();
    badPressMatchRecord.badPressEntity = this.badPressMatchRecord.badPressEntity;
    badPressMatchRecord.relationEntityId = this.relationEntityId;
    badPressMatchRecord.matchResolution = value.matchResolution;
    badPressMatchRecord.falseMatchReason = value.falseMatch;
    badPressMatchRecord.comments = value.comments;
    this.badPressService.markBadPressResolve(badPressMatchRecord).subscribe(response => {
      if (response.flagResult) {
        this.dialogRef.close(badPressMatchRecord);
      }
      this.callSnackBarService(response);
    }, err => {
      this.callSnackBarService(err);
    });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
        MessageService.BADPRESS_RESOLVE_SUCCESS,
        MessageService.BADPRESS_RESOLVE_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress/resolvebadpress/resolve-badpress.component.ts